import { Routes, Route } from 'react-router-dom'
import { EditProvider } from '@/contexts/EditContext'
import { EditorBar } from '@/components/editable'
import { AdminLayout } from '@/components/admin'

// Admin pages (keep media for now)
import { Media } from '@/pages/admin'

// Public pages
import { Home, DynamicPage } from '@/pages/site'

export function App() {
  return (
    <Routes>
      {/* Public routes (view mode) */}
      <Route path="/" element={<Home />} />
      <Route path="/:slug" element={<DynamicPage />} />

      {/* Admin routes (edit mode - same pages with inline editing) */}
      <Route
        path="/admin"
        element={
          <EditProvider>
            <Home />
            <EditorBar />
          </EditProvider>
        }
      />
      <Route
        path="/admin/page/:slug"
        element={
          <EditProvider>
            <DynamicPage />
            <EditorBar />
          </EditProvider>
        }
      />

      {/* Keep media library accessible via old admin layout */}
      <Route
        path="/admin/media"
        element={
          <AdminLayout>
            <Media />
          </AdminLayout>
        }
      />
    </Routes>
  )
}
